/**
 * 쪽 번호 줄에 무엇을 보여 줄까.
 *
 * 처음·끝·현재 ±1 만 남기고 사이는 접는다("gap"). 200쪽짜리 목록에서 번호를 다 그리면
 * 줄이 넘치고, "이전/다음"만 두면 어제 보던 자리로 돌아갈 방법이 없다.
 */
export function pageNumbers(page: number, lastPage: number): (number | "gap")[] {
  const out: (number | "gap")[] = []
  for (let p = 1; p <= lastPage; p++) {
    if (p === 1 || p === lastPage || Math.abs(p - page) <= 1) out.push(p)
    else if (out[out.length - 1] !== "gap") out.push("gap")
  }
  return out
}
